import { useContext} from "react";
import {GlobalContext} from "@tools/globalContext";
import { useEventEmitter } from "@hooks/useEventEmitter";

const useSocketEventManipulator = () => {
    const { user } = useContext(GlobalContext);
    const {useListener} = useEventEmitter();

    useListener("beforeSocketEvent", data => {
        // if(data.type === "create_order" && user.company?.id === data.data?.to?.id)
        //     return {success: true, data: Object.assign({}, data, {type: "create_request"})}
        // if(data.type === "update_order" && user.company?.id === data.data?.to?.id)
        //     return {success: true, data: Object.assign({}, data, {type: "update_request"})}

        return {success: true}
    })

    return {}
   
}

export default useSocketEventManipulator
